angular.module('procommTalentSearch').controller('checkSize', ['screenSize', function (screenSize) {
  var data = complicatedChartData;

  //Determine to either perform cpu/network-intensive actions(desktop) or retrieve a small static image(mobile). 
  if (screenSize.is('xs, sm')) {
	console.log('testy1!');
  }
  else {
  	console.log('testy2!');
  }
}]);